export default __webpack_public_path__ + "static/media/08-EXT-(4-4).f0c084e7.jpg";